export default Object.freeze({
    select: 'select',
    text: 'text',
    group: 'group',
})
